import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addFromColumn,
    sortCurrency, sortNumber,
    toCurrency,
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {convertStartAndEndDatesForFile} from '../shared/printFunctions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import DetailIcon from 'material-ui/svg-icons/image/remove-red-eye';
import VIPPointsTableIcon from 'material-ui/svg-icons/action/grade';

/**
 * Class for displaying Points Spent Summary in a table
 *
 */
class VIPTrendsPointsLocationTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'Location', key: 'location_id'},
                {label: 'City', key: 'city'},
                {label: 'State', key: 'state'},
                {label: '$ Spent that Earned Points', key: 'subtotal_spent'},
                {label: 'Points Spent', key: 'pts_spent'},
                {label: 'Points Spent $ Value', key: 'pts_spent_value'}
            ],
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSortChange = this.handleSortChange.bind(this);
    }

    componentWillMount() {
        this.processData(this.props.listData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.listData !== this.props.listData) {
            this.setState({
                summaryList: nextProps.listData,
                summaryTableData: nextProps.listData
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listData !== this.props.listData) {
            this.processData(this.props.listData);
        }
    }

    /* Data Processing ------------------------------ */

    /**
     * Set data for use by table
     *
     * @param listData
     */
    processData(listData) {
        this.setState({
            summaryList: listData,
            summaryTableData: listData
        });
    }

    /* Table Building ------------------------------ */

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortChange(event, table) {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    }

    /**
     * Update selected table data based on filter
     *
     * @param event
     * @param table
     */
    handleFilterChange(event, table) {
        const tableData = getTableState(table);
        this.setState({
            summaryTableData: tableData
        });
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            allowLocationSelection,
            endDate,
            locationIconFunction,
            startDate,
            system,
            tableKey
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders
        } = this.state;

        const dateString = convertStartAndEndDatesForFile(startDate, endDate);
        const defaultSort = setDefaultTableSort('location_id');
        const iconStyle = (allowLocationSelection) ? tableStyles.tableIconButton : tableStyles.disabledTableIconButton;

        // Headers and columns for ReactTable
        const tableColumns = [
            {
                Header: 'Location',
                columns: [
                    {
                        Header: 'Location',
                        accessor: 'location_id',
                        sortMethod: (a, b) => sortNumber(a, b, 'ASC'),
                        Cell: row => (
                            <span>
                        <span>{row.row.location_id}</span>
                        <DetailIcon
                            onClick={(e) => locationIconFunction(e, row.row)}
                            style={iconStyle}
                        />
                    </span>
                        ),
                        style: tableStyles.right,
                    },
                    {
                        Header: 'City',
                        accessor: 'city',
                    },
                    {
                        Header: 'State',
                        accessor: 'state',
                        style: tableStyles.tdMax,
                    }
                ]
            },
            {
                Header: 'Points',
                columns: [
                    {
                        Header: () => (<span>$ Spent that<br/>Earned Points</span>),
                        accessor: 'subtotal_spent',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'subtotal_spent'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Points Spent',
                        accessor: 'pts_spent',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'pts_spent'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Points Spent<br/>$ Value</span>),
                        accessor: 'pts_spent_value',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'pts_spent_value'))}
                            </span>
                        )
                    }
                ]
            }
        ];

        return (
            <div>
                <div className="reports-table-container">

                    {/* Table Header: Total VIP Points Spent and Earned */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container report-header-button-container">
                            {/* Export VIP Trends - Total VIP Points Spent and Earned */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={'VIP-Trends-Points-' + system + '-' + dateString + '.csv'}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export Total VIP Points Spent and Earned
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <VIPPointsTableIcon style={commonStyles.summaryIcon}/>
                            <span>Total VIP Points Spent and Earned</span>
                        </h3>
                    </div>

                    {/* Table: Total Points Spent and Earned */}
                    <ReactTable
                        key={`table-vip-location-points-${tableKey}`}
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={5}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortChange(e, this.locationPointsReacttable)}
                        onFilteredChange={(e) => this.handleFilterChange(e, this.locationPointsReacttable)}
                        ref={(r) => this.locationPointsReacttable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow no-print"
                    />
                    <ReactTable
                        key={`table-vip-location-points-print-${tableKey}`}
                        data={summaryTableData}
                        columns={tableColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        defaultSorted={defaultSort}
                        filterable
                        resizable={false}
                        minRows={1}
                        className="print-only"
                    />
                </div>
            </div>
        )
    }
}

VIPTrendsPointsLocationTable.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    allowLocationSelection: PropTypes.bool,
    listData: PropTypes.array,
    locationIconFunction: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
    tableKey: PropTypes.string
};

VIPTrendsPointsLocationTable.defaultProps = {
    addField: true,
    endDate: null,
    allowLocationSelection: true,
    startDate: null,
    tableKey: 'points-location'
};

export default VIPTrendsPointsLocationTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/VIPTrendsPointsLocationTable.js